import React from "react";
import {
  Container,
  Header,
  Content,
  Form,
  ButtonToolbar,
  Button,
  Navbar,
  Panel,
  FlexboxGrid,
  Radio,
  RadioGroup,
  Whisper,
  Tooltip,
  IconButton,
  Nav,
  Input,
} from "rsuite";
import PlusIcon from "@rsuite/icons/Plus";
import TrashIcon from "@rsuite/icons/Trash";
import PageNext from "@rsuite/icons/PageNext";
import ArowBack from "@rsuite/icons/ArowBack";
import CheckOutline from "@rsuite/icons/CheckOutline";
import InfoRoundIcon from "@rsuite/icons/InfoRound";
import CheckIcon from "@rsuite/icons/Check";

import Logo from "./logo.png";

import { UrlValidator } from "./validators";
import { Alert } from "./Alert/Alert";
import { NunetLoader } from "./components/NunetLoader";

import { SERVICE_TYPE } from "./constants";
import { imageMapper } from "./containers/image";
import { constraintsMapper } from "./containers/constraints";
import { Calculate_Static_NTX_GPU } from "./containers/max_ntx";
import { sendComputeRequest } from "./services/api";
import { Typhon } from "./services/typhon";
import { Eternl } from "./services/eternl";

export const AppForm = () => {
  const [page, setPage] = React.useState(1);

  const [libs, setLibs] = React.useState([]);
  const addField = () => {
    const key = Math.floor(Math.random() * 100000000) + 1;
    setLibs([...libs, key]);
  };
  const deleteField = (index) => {
    const newLibs = [...libs];
    newLibs.splice(index, 1);
    setLibs(newLibs);
  };

  const [form, setForm] = React.useState({
    url: "",
    framework: "Tensorflow",
    time: 1,
    userAddress: "",
    ntx: 0,
    blockChain: "Cardano",
    complexity: "Low",
  });
  const [libValues, setLibValues] = React.useState({});
  const [errors, setErrors] = React.useState([]);

  const [minPrice, setMinPrice] = React.useState(0);
  React.useEffect(() => {
    const p = Calculate_Static_NTX_GPU(form.complexity, form.time);
    setMinPrice(p);
  }, [form]);

  const typhon = new Typhon(window);
  const [typhonEnabled, setTyphonEnabled] = React.useState(false);

  const _typhonOnLoad = async () => {
    let windowCardano = window.cardano;
    if (windowCardano) {
      let windowTyphon = window.cardano.typhon;
      if (windowTyphon) {
        const typhonResponse = await typhon.isEnabled();
        if (typhonResponse) {
          console.log("I'm triggered");
          setTyphonEnabled(true);
        }
      }
    }
  };

  const _enableTyphon = async () => {
    let windowCardano = window.cardano;
    if (!windowCardano) {
      alert("Please Download Typhon Browser Extension");
    } else {
      let windowTyphon = window.cardano.typhon;
      if (!windowTyphon) {
        alert("Please Download Typhon Browser Extension");
      } else {
        const typhonResponse = await typhon.prepare();
        if (typhonResponse) {
          setTyphonEnabled(true);
        } else {
          alert("Please Enable Typhon");
        }
      }
    }
  };

  const eternl = new Eternl(window);
  const [eternlEnabled, setEternlEnabled] = React.useState(false);

  const _eternlOnLoad = async () => {
    let windowCardano = window.cardano;
    if (windowCardano) {
      let windowEternl = window.cardano.eternl;
      if (windowEternl) {
        const eternlResponse = await eternl.isEnabled();
        if (eternlResponse) {
          console.log("I'm triggered");
          setEternlEnabled(true);
        }
      }
    }
  };

  const _enableEternl = async () => {
    let windowCardano = window.cardano;
    if (!windowCardano) {
      alert("Please Download Eternl Browser Extension");
    } else {
      let windowEternl = window.cardano.eternl;
      if (!windowEternl) {
        alert("Please Download Eternl Browser Extension");
      } else {
        const eternlResponse = await eternl.prepare();
        if (eternlResponse) {
          setEternlEnabled(true);
        } else {
          alert("Please Enable Eternl");
        }
      }
    }
  };

  const onChangingPage = () => {
    setErrors([]);

    const collectedErrors = [];

    if (form.url.trim().length === 0) {
      collectedErrors.push("Please Enter a URL");
    }
    if (!UrlValidator.test(form.url)) {
      collectedErrors.push("Please Enter a valid URL");
    }

    if (form.time.toString().trim().length === 0) {
      collectedErrors.push("Please Enter an Estimated Time");
    }

    if (form.time < 1) {
      collectedErrors.push("Estimated time must be greater than 0");
    }

    if (collectedErrors.length > 0) {
      setErrors([...collectedErrors]);
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    } else {
      setPage(2);
    }
  };

  const onSubmit = () => {
    setErrors([]);

    const collectedErrors = [];

    if (form.userAddress.trim().length === 0) {
      collectedErrors.push("Please Get Your User Address From Your Wallet.");
    }

    if (form.ntx.toString().trim().length === 0) {
      collectedErrors.push("Please Enter an NTX number");
    }

    if (form.ntx < minPrice) {
      collectedErrors.push("NTX Number Can't be less than the minimum");
    }

    if (collectedErrors.length > 0) {
      setErrors([...collectedErrors]);
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    } else {
      const data = { ...form };
      const collectedLibraries = [];
      libs.forEach((lib) => {
        if (libValues[lib] !== undefined) {
          collectedLibraries.push(libValues[lib].trim());
        }
      });
      data["libs"] = collectedLibraries.filter(
        (l) => l !== undefined && l.length > 0
      );
      const keys = Object.keys(data);
      keys.forEach((key) => {
        if (typeof data[key] === "string") {
          data[key] = data[key].trim();
        }
      });
      data["ntx"] = parseInt(data["ntx"]);
      data["time"] = parseInt(data["time"]);
      const postData = {
        address_user: data.userAddress,
        max_ntx: data.ntx,
        blockchain: data.blockChain,
        service_type: SERVICE_TYPE,
        params: {
          image_id: imageMapper(data.framework),
          model_url: data.url,
          packages: data.libs,
        },
        constraints: { ...constraintsMapper(data.complexity), time: data.time },
      };
      console.log(JSON.stringify(postData));

      sendComputeRequest(postData)
        .then((r) => console.log(r))
        .catch((e) => console.error(e));
    }
  };

  const FetchTyphonAddress = () => {
    setForm({ ...form, userAddress: "Loading..." });
    window.cardano.typhon.getAddress().then((data) => {
      if (data.status) {
        setForm({ ...form, userAddress: data.data });
      }
    });
  };

  const FetchEternlAddress = async () => {
    if (eternlEnabled) {
      setForm({ ...form, userAddress: "Loading..." });
      const api = await window.cardano.eternl.enable();
      const address = await api.getChangeAddress();
      setForm({ ...form, userAddress: address });
    }
  };

  return (
    <NunetLoader
      duration={2000}
      onFinsih={() => {
        _typhonOnLoad();
        _eternlOnLoad();
      }}
    >
      <div className="show-fake-browser login-page">
        <Container>
          <Header>
            <Navbar appearance="inverse" style={{ background: "#0a2042" }}>
              <Navbar.Brand style={{ textAlign: "left" }}>
                <span style={{ color: "#fff" }}>
                  <img
                    src={Logo}
                    alt="logo"
                    style={{
                      width: "100px",
                      marginTop: "-5px",
                      textAlign: "left",
                    }}
                  />
                </span>
              </Navbar.Brand>
              <Nav pullRight>
                {typhonEnabled ? (
                  <Nav.Item style={{ background: "#2ecc71" }}>
                    Typhon <CheckIcon style={{ marginLeft: "5px" }} />
                  </Nav.Item>
                ) : (
                  <Nav.Item onClick={_enableTyphon}>Connect Typhon</Nav.Item>
                )}
                {eternlEnabled ? (
                  <Nav.Item style={{ background: "#2ecc71" }}>
                    Eternl <CheckIcon style={{ marginLeft: "5px" }} />
                  </Nav.Item>
                ) : (
                  <Nav.Item onClick={_enableEternl}>Connect Eternl</Nav.Item>
                )}
              </Nav>
            </Navbar>
          </Header>
          {errors.length > 0 && <Alert text={errors[0]} />}
          {page === 1 ? (
            <Content>
              <FlexboxGrid justify="center" style={{ margin: "2rem 0" }}>
                <FlexboxGrid.Item colspan={12} className="flex-panel-container">
                  <Panel
                    style={{ background: "white", padding: "10px" }}
                    className="flex-panel"
                    header={
                      <h4
                        style={{
                          textAlign: "center",
                          fontWeight: "300",
                          marginBottom: "20px",
                        }}
                      >
                        Enter your GPU ML Requirements 🚀
                        <hr />
                      </h4>
                    }
                    shaded
                  >
                    <Form fluid onSubmit={() => onChangingPage()}>
                      <Form.Group>
                        <Form.ControlLabel style={{ position: "relative" }}>
                          ML Model URL:
                          <Whisper
                            trigger="hover"
                            placement="left"
                            speaker={
                              <Tooltip>Link to Python ML Model (URL)</Tooltip>
                            }
                          >
                            <IconButton
                              size="xs"
                              circle
                              style={{
                                position: "absolute",
                                right: "0",
                                top: "-3px",
                              }}
                              icon={<InfoRoundIcon color="#78909b" />}
                            />
                          </Whisper>
                        </Form.ControlLabel>
                        <Form.Control
                          value={form.url}
                          name="url"
                          onChange={(v) =>
                            setForm({ ...form, url: v.replace(/\s/gi, "") })
                          }
                        />
                      </Form.Group>

                      <Form.Group
                        name="framework"
                        label="Which framework does it use?"
                      >
                        <Form.ControlLabel style={{ position: "relative" }}>
                          Framework of the ML Model:
                          <Whisper
                            trigger="hover"
                            placement="left"
                            speaker={
                              <Tooltip>
                                The framework that the ML Model uses
                              </Tooltip>
                            }
                          >
                            <IconButton
                              size="xs"
                              circle
                              style={{
                                position: "absolute",
                                right: "0",
                                top: "-3px",
                              }}
                              icon={<InfoRoundIcon color="#78909b" />}
                            />
                          </Whisper>
                        </Form.ControlLabel>
                        <RadioGroup
                          name="framework"
                          inline
                          value={form.framework}
                          onChange={(v) => setForm({ ...form, framework: v })}
                        >
                          <Radio value={"Tensorflow"}>TensorFlow</Radio>
                          <Radio value={"Pytorch"}>PyTorch</Radio>
                        </RadioGroup>
                        <Form.HelpText
                          style={{ fontSize: "12px", marginLeft: "10px" }}
                        >
                          Learn more about{" "}
                          <a
                            href="https://www.tensorflow.org/"
                            target="_blank"
                            rel="noreferrer"
                          >
                            TensorFlow
                          </a>{" "}
                          and{" "}
                          <a
                            href="https://pytorch.org/"
                            target="_blank"
                            rel="noreferrer"
                          >
                            PyTorch
                          </a>
                        </Form.HelpText>
                      </Form.Group>

                      <Form.Group name="complexity" label="Complexity">
                        <Form.ControlLabel style={{ position: "relative" }}>
                          Resource Usage:
                          <Whisper
                            trigger="hover"
                            placement="left"
                            speaker={
                              <Tooltip>
                                Corresponding GPU resource would be allocated
                                based on your requirement
                              </Tooltip>
                            }
                          >
                            <IconButton
                              size="xs"
                              circle
                              style={{
                                position: "absolute",
                                right: "0",
                                top: "-3px",
                              }}
                              icon={<InfoRoundIcon color="#78909b" />}
                            />
                          </Whisper>
                        </Form.ControlLabel>
                        <RadioGroup
                          name="blockchain"
                          inline
                          value={form.complexity}
                          onChange={(v) => setForm({ ...form, complexity: v })}
                        >
                          <Radio value={"Low"}>Low</Radio>
                          <Radio value={"Moderate"}>Moderate</Radio>
                          <Radio value={"High"}>High</Radio>
                        </RadioGroup>
                      </Form.Group>

                      <Form.Group
                        style={{
                          position: "relative",
                          background: "rgb(245, 245, 245)",
                          padding: "10px",
                          borderRadius: "5px",
                        }}
                      >
                        <Form.ControlLabel style={{ marginBottom: "10px" }}>
                          Please enter any additional required dependencies:{" "}
                          <Whisper
                            trigger="hover"
                            placement="top"
                            speaker={<Tooltip>Add Dependencies</Tooltip>}
                          >
                            <IconButton
                              style={{
                                position: "absolute",
                                right: "10px",
                                top: "4px",
                              }}
                              icon={<PlusIcon color="#45089b" />}
                              circle
                              onClick={addField}
                            ></IconButton>
                          </Whisper>
                        </Form.ControlLabel>
                        {libs.length > 0 &&
                          libs.map((l, index) => (
                            <div style={{ display: "flex" }} key={l}>
                              <Whisper
                                trigger="hover"
                                placement="top"
                                speaker={<Tooltip>Delete</Tooltip>}
                              >
                                <IconButton
                                  style={{ height: "100%", marginTop: "5px" }}
                                  icon={<TrashIcon color="#ec297b" />}
                                  onClick={() => deleteField(index)}
                                />
                              </Whisper>
                              <Form.Control
                                style={{ margin: "5px 0" }}
                                name={`deps${l}`}
                                value={
                                  libValues[l] !== undefined ? libValues[l] : ""
                                }
                                onChange={(v) => {
                                  const result = v.replace(/\s/gi, "");
                                  setLibValues({ ...libValues, [l]: result });
                                }}
                                className="small_placeholder"
                                placeholder="Enter a package name to install with pip, before deploying your ML Job"
                              />
                            </div>
                          ))}
                      </Form.Group>

                      <Form.Group>
                        <Form.ControlLabel style={{ position: "relative" }}>
                          Estimated Computation Time (in minutes)
                          <Whisper
                            trigger="hover"
                            placement="left"
                            speaker={
                              <Tooltip>
                                Expected time for your ML job to be completed
                              </Tooltip>
                            }
                          >
                            <IconButton
                              size="xs"
                              circle
                              style={{
                                position: "absolute",
                                right: "0",
                                top: "-3px",
                              }}
                              icon={<InfoRoundIcon color="#78909b" />}
                            />
                          </Whisper>
                        </Form.ControlLabel>

                        <Form.Control
                          name="time"
                          type="number"
                          autoComplete="off"
                          value={form.time}
                          min="1"
                          onChange={(v) => setForm({ ...form, time: v })}
                        />
                      </Form.Group>

                      <Form.Group>
                        <ButtonToolbar className="right">
                          <Button
                            placement="right"
                            appearance="primary"
                            className="gr-btn"
                            size="lg"
                            type="submit"
                          >
                            Next
                            <PageNext />
                          </Button>
                        </ButtonToolbar>
                      </Form.Group>
                    </Form>
                  </Panel>
                </FlexboxGrid.Item>
              </FlexboxGrid>
            </Content>
          ) : (
            <Content>
              <FlexboxGrid justify="center" style={{ margin: "2rem 0" }}>
                <FlexboxGrid.Item colspan={12} className="flex-panel-container">
                  <Panel
                    style={{ background: "white", padding: "10px" }}
                    className="flex-panel"
                    header={
                      <h4
                        style={{
                          textAlign: "center",
                          fontWeight: "300",
                          marginBottom: "15px",
                          position: "relative",
                          fontSize: "30px",
                        }}
                      >
                        <Whisper
                          trigger="hover"
                          placement="top"
                          speaker={<Tooltip>Back</Tooltip>}
                        >
                          <IconButton
                            style={{ position: "absolute", left: "10px" }}
                            size="md"
                            onClick={() => setPage(1)}
                            icon={<ArowBack color="#45089b" />}
                          />
                        </Whisper>
                        Tokenomics
                        <hr />
                      </h4>
                    }
                    bordered
                    shaded
                  >
                    <Form fluid onSubmit={onSubmit}>
                      <Form.Group>
                        <Form.ControlLabel style={{ position: "relative" }}>
                          User Address:
                          <Whisper
                            trigger="hover"
                            placement="left"
                            speaker={<Tooltip>The Address of the user</Tooltip>}
                          >
                            <IconButton
                              size="xs"
                              circle
                              style={{
                                position: "absolute",
                                right: "0",
                                top: "-3px",
                              }}
                              icon={<InfoRoundIcon color="#78909b" />}
                            />
                          </Whisper>
                        </Form.ControlLabel>
                        <div style={{}}>
                          <Input
                            as={"textarea"}
                            name="useraddress"
                            value={form.userAddress}
                            readOnly={true}
                            rows={3}
                            placeholder="Get Address From Typhon Or Eternl"
                          />
                          {!typhonEnabled && !eternlEnabled && (
                            <Form.HelpText>
                              Please Connect one of the wallets from above to
                              Get Address.
                            </Form.HelpText>
                          )}
                          <Whisper
                            trigger="hover"
                            placement="right"
                            speaker={
                              <Tooltip>
                                {typhonEnabled
                                  ? "Get Typhon Address"
                                  : "Enable Typhon to use Address"}
                              </Tooltip>
                            }
                          >
                            <Button
                              style={{
                                height: "100%",
                                marginTop: "5px",
                                marginRight: "10px",
                              }}
                              appearance="primary"
                              disabled={!typhonEnabled}
                              onClick={FetchTyphonAddress}
                            >
                              Use Typhon Address
                            </Button>
                          </Whisper>
                          <Whisper
                            trigger="hover"
                            placement="right"
                            speaker={
                              <Tooltip>
                                {eternlEnabled
                                  ? "Get Eternl Address"
                                  : "Enable Eternl to use Address"}
                              </Tooltip>
                            }
                          >
                            <Button
                              style={{ height: "100%", marginTop: "5px" }}
                              appearance="primary"
                              disabled={!eternlEnabled}
                              onClick={FetchEternlAddress}
                            >
                              Use Eternl Address
                            </Button>
                          </Whisper>
                        </div>
                      </Form.Group>

                      <Form.Group>
                        <Form.ControlLabel style={{ position: "relative" }}>
                          Max tokens amount:
                          <Whisper
                            trigger="hover"
                            placement="left"
                            speaker={
                              <Tooltip>
                                Max tokens amount to pay for compute job
                              </Tooltip>
                            }
                          >
                            <IconButton
                              size="xs"
                              circle
                              style={{
                                position: "absolute",
                                right: "0",
                                top: "-3px",
                              }}
                              icon={<InfoRoundIcon color="#78909b" />}
                            />
                          </Whisper>
                        </Form.ControlLabel>

                        <Form.Control
                          name="ntx"
                          type="number"
                          autoComplete="off"
                          min={0}
                          value={form.ntx}
                          onChange={(v) => setForm({ ...form, ntx: v })}
                        />
                        <Form.HelpText>
                          The Field can't be less than {minPrice.toFixed(5)} NTX
                          based on your Requirements
                        </Form.HelpText>
                      </Form.Group>

                      <Form.Group name="blockchain" label="Blockchain">
                        <Form.ControlLabel style={{ position: "relative" }}>
                          Blockchain:
                          <Whisper
                            trigger="hover"
                            placement="left"
                            speaker={<Tooltip>The blockchain needed</Tooltip>}
                          >
                            <IconButton
                              size="xs"
                              circle
                              style={{
                                position: "absolute",
                                right: "0",
                                top: "-3px",
                              }}
                              icon={<InfoRoundIcon color="#78909b" />}
                            />
                          </Whisper>
                        </Form.ControlLabel>
                        <RadioGroup
                          name="blockchain"
                          inline
                          value={form.blockChain}
                          onChange={(v) => setForm({ ...form, blockChain: v })}
                        >
                          <Radio value={"Cardano"}>Cardano</Radio>
                          <Radio value={"Ethereum"}>Ethereum</Radio>
                        </RadioGroup>
                      </Form.Group>

                      <Form.Group>
                        <ButtonToolbar>
                          <Button
                            appearance="primary"
                            size="lg"
                            className="gr-btn"
                            style={{ width: "100%" }}
                            type="submit"
                            disabled={!typhonEnabled && !eternlEnabled}
                          >
                            <CheckOutline /> Submit
                          </Button>
                          {!typhonEnabled && !eternlEnabled && (
                            <Form.HelpText>
                              You have to enable Typhon or Eternl to submit.
                            </Form.HelpText>
                          )}
                        </ButtonToolbar>
                      </Form.Group>
                    </Form>
                  </Panel>
                </FlexboxGrid.Item>
              </FlexboxGrid>
            </Content>
          )}
        </Container>
      </div>
    </NunetLoader>
  );
};
